// DownloadAppBanner.tsx
import React, { useEffect, useState } from "react";
import { useMobilePlatform } from "../hooks/useMobilePlatform";

const DISMISS_KEY = "downloadAppBannerDismissed_v1";

// type Props = {
//   iosUrl?: string;
//   androidUrl?: string;
// };

// export const DownloadAppBanner: React.FC<Props> = ({
export default function DownloadAppBanner({ androidUrl, iosUrl }) {
  const platform = useMobilePlatform();
  const [dismissed, setDismissed] = useState(false);
  const [ready, setReady] = useState(false);

  // Read persisted dismissal
  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = window.localStorage.getItem(DISMISS_KEY);
    setDismissed(stored === "true");
    setReady(true);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(DISMISS_KEY, "true");
    }
  };

  const handleOpenStore = () => {
    if (!platform) return;

    const url = platform === "ios" ? iosUrl : androidUrl;
    window.location.href = url;
  };

  // Don’t render:
  // - until we've checked localStorage
  // - if dismissed
  // - if not on iOS/Android
  if (!ready || dismissed || !platform) return null;

  const isIOS = platform === "ios";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: "#464646",
        color: "white",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      {/* Icon / logo placeholder */}
      <div
        style={{
          color: "#000",
          width: 40,
          height: 40,
          borderRadius: 10,
          background: "#27bb4e", // amber-ish
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 20,
          flexShrink: 0,
          fontFamily: "joystix"
        }}
      >
        M
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>
          Get the {isIOS ? "iOS" : "Android"} app
        </div>
        <div style={{ fontSize: 12, opacity: 0.9 }}>
          For a faster, smoother experience, use our{" "}
          {isIOS ? "iPhone/iPad app from the App Store." : "Android app from Google Play."}
        </div>
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button
          type="button"
          onClick={handleOpenStore}
          style={{
            border: "none",
            borderRadius: 9999,
            padding: "6px 12px",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            background: "white",
            color: "#111827",
            whiteSpace: "nowrap",
          }}
        >
          {isIOS ? "Open App Store" : "Open Play Store"}
        </button>

        <button
          type="button"
          onClick={handleDismiss}
          aria-label="Dismiss banner"
          style={{
            border: "none",
            background: "transparent",
            color: "white",
            fontSize: 18,
            cursor: "pointer",
            padding: 4,
            lineHeight: 1,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

